/** Minimal storage contract — `Window.localStorage` satisfies it. */
export interface BestScoreStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function bestScoreKey(year: string): string {
  return `bmbt:best:${year}`;
}

export function readBestScore(store: BestScoreStore, year: string): number {
  const raw = store.getItem(bestScoreKey(year));
  if (raw === null) {
    return 0;
  }
  const value = Number(raw);
  return Number.isInteger(value) && value >= 0 ? value : 0;
}

/** Stores `score` only if it beats the current best for `year`. Returns true on a new best. */
export function recordBestScore(store: BestScoreStore, year: string, score: number): boolean {
  if (!Number.isInteger(score) || score < 0) {
    return false;
  }
  if (score <= readBestScore(store, year)) {
    return false;
  }
  store.setItem(bestScoreKey(year), String(score));
  return true;
}
